import { useContext } from "react";
import { AudioContextHandles } from "providers/AudioProvider/audioProvider";

export const useAudioHandlesContext = () => {
  return useContext(AudioContextHandles);
};
